import { brand } from "../../../../branchAndBrandSpecific/utils/brandVariables/brandVariables";
import battlenetLogo from "../assets/auth-bnet.svg";
import steamLogo from "../assets/auth-steam.svg";
export const auhtOptions = [
  brand.hasAuth.steam ? [steamLogo, "#2D2E33", "steam", "STEAM", "STEAM"] : [],
  brand.hasAuth.bnet
    ? [battlenetLogo, "#2D2E33", "bnet", "Battle.net", "Battle.net"]
    : [],
];
